<template>
  <v-flex xs12 row>
    <v-layout py-3>
   		<v-flex xs12>
   			<v-form v-model="validForm">
          <v-card>
            <v-card-title class="px-4">
              
              <v-flex xs6 sm3>
                <div class="subheading text-uppercase font-weight-light">
                  <span>Dispatch No.: </span>
                  <span>{{dispatch.id}}</span>
                </div>
              </v-flex>

              <v-flex xs12 sm6 class="text-xs-center">
                <span class="headline text-uppercase font-weight-light pt-4" v-text="`${pageType} Stock Dispatch`"></span>
              </v-flex>

              <v-flex xs6 sm3 class="text-xs-right">
                <div class="body-2 font-weight-light py-2">
                  <v-icon class="mr-1">date_range</v-icon>
                  <span>{{dispatch.date}}</span>
                </div>
              </v-flex>
              
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md class="grey lighten-5">
                
                <v-layout wrap>
                  
                  <v-flex xs12 sm4>
                    <v-autocomplete v-model="dispatch.factory_id" :items="factories" item-text="title" item-value="id" label="Dispatch From" :readonly="viewMode"></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm4>
                    <v-autocomplete v-model="dispatch.warehouse_id" :items="warehouses" item-text="title" item-value="id" label="Dispatch To" :readonly="viewMode"></v-autocomplete>
                  </v-flex>

                </v-layout>

              </v-container>

              <v-container grid-list-md py-0 v-if="!viewMode">

                <v-layout wrap>
                  <v-flex xs12 sm3>
                    <v-autocomplete :loading="itemLoading" v-model="itemId" :search-input.sync="itemCodeSearch" :items="searchItems" item-text="item_code" item-value="id" label="Search Item Code" hide-no-data :disabled="!dispatch.factory_id">
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title v-text="data.item.item_code"></v-list-tile-title>
                          <v-list-tile-sub-title class="caption" v-text="data.item.category_name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-autocomplete :loading="itemLoading" v-model="itemId" :search-input.sync="itemNameSearch" :items="searchItems" item-text="title" item-value="id" label="Search Item Name" hide-no-data :disabled="!dispatch.factory_id">
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                          <v-list-tile-sub-title class="caption" v-text="data.item.category_name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <div>
                      <div class="v-table__overflow">
                        <table class="v-datatable v-table">
                          <thead>
                            <tr>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Code</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Name</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Unit</span>
                              </th>
                              <th role="columnheader" scope="col" class="column" :class="viewMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!viewMode">
                                <span>Stock QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!viewMode">
                                <span>Actions</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="dispatch.items && dispatch.items.length > 0">
                            <tr is="dispatch-item" v-for="(item, index) in dispatch.items" v-bind:item="item" v-bind:index="index" v-on:delete="deleteItem" :viewMode="viewMode"></tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="8">No Items Added</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>

            <v-card-actions v-if="!viewMode">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat :disabled="processing" to="/stock-dispatch-list">Cancel</v-btn>
              <v-btn color="blue darken-1" flat :disabled="!validForm || processing || !hasEnoughStock" :loading="processing" @click.native="upsertStockDispatch" v-text="dispatch.id ? 'Update' : 'Save'"></v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>
  
  import StockDispatchItem from './StockDispatchItem'

  export default {
    name: 'StockDispatch',
    props: {
      viewMode: {
        default: false
      }
    },
    data () {
      return {
      	title: "Stock Dispatch",
        validForm: false,
      	processing: false,
        itemLoading: false,
        itemNameLoading: false,
        factories: [],
        warehouses: [],
        itemId: null,
        itemCodeSearch: "",
        itemNameSearch: "",
        searchItems: [],
        dispatch: {},
        defaultDispatch: {
          id: "",
          date: this.today('YYYY-MM-DD'),
          warehouse_id: null,
          factory_id: this.getDefault('factory'),
          items: []
        }

      }
    },
    created () {

      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Stock Dispatch',
            disabled: false,
            href: '/stock-dispatch-list'
	        },
	        {
	          text: this.pageType,
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Stock Dispatch')
    },
    methods: {

      searchItemsByParam (key, val) {

        this.itemLoading = true
        this.axios.get(`${this.config.apis.searchItems}?${key}=${val}&stock=true&factory=${this.dispatch.factory_id}`)
        .then((response) => {
            this.itemLoading = false
            if (this.isSuccessResponse(response)) {
              this.searchItems = response.data.data
            }
        })
        .catch((error) => {
            this.itemLoading = false
        })
      },

      searchItemsByCode () {
        this.searchItemsByParam('item_code', this.itemCodeSearch)
      },

      searchItemsByName () {
        this.searchItemsByParam('title', this.itemNameSearch)
      },

      upsertItemFromListToDispatch (val) {

        let exist = this.dispatch.items.findIndex(item => item.item_id === val)

        // if item already exists, then increase quantity else add new item
        if (exist == -1) {
          let item = this.searchItems.filter(item => item.id === val)

          if (item.length > 0) {
            //add new item at the first index of items array
            let new_item = this.extend({quantity:1, item_id: item[0].id}, item[0])
            delete new_item.id
            this.dispatch.items.splice(0, 0, new_item)
            
          }
        }

        this.clearItemAutoComplete()

      },

      clearItemAutoComplete () {
        this.itemCodeSearch = ""
        this.itemNameSearch = ""
        setTimeout(() => {
          this.itemId = null
        }, 100)
      },

      upsertStockDispatch () {

        if (this.dispatch.items.length === 0) return this.notifyError('emptyStockDispatchItems')
        if (!this.dispatch.warehouse_id) return this.notifyError('emptyStockDispatchWarehouse')
        if (!this.dispatch.factory_id) return this.notifyError('emptyStockDispatchFactory')

        this.processing = true

        let data = this.extend(this.dispatch)

        let method = data.id ? 'put' : 'post'
        let api_path = data.id ? this.config.apis.updateStockDispatch.replace(":id", data.id) : this.config.apis.saveStockDispatch

        this.axios[method](api_path, data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              let successStatus = data.id ? 'updateStockDispatchSuccess' : 'insertStockDispatchSuccess'

              this.notifySuccess(successStatus)
              this.$router.push("/stock-dispatch-list")
            }
            else{

              let errorStatus = data.id ? 'updateError' : 'insertError'

              this.notifyError(errorStatus)
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      deleteItem (index) {
        this.dispatch.items.splice(index, 1)
      },

      initNewStockDispatch () {
        this.dispatch = this.extend({}, this.defaultDispatch)
      },

      loadStockDispatch (dispatchId) {
        this.processing = true
        
        let api_path = this.config.apis.getStockDispatch.replace(":id", dispatchId)

        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.dispatch = response.data.data
            }
            else{
              this.dispatch = this.initNewStockDispatch()
            }
          })
          .catch((error) => {
            this.processing = false
          })
      }

    },
    mounted () {

      this.getAllData('factory')
        .then((response) => {
          this.factories = response
        })

      this.getAllData('warehouse')
        .then((response) => {
          this.warehouses = response
        })

      if (this.$route.params.dispatchId) {
        this.loadStockDispatch(this.$route.params.dispatchId)
      }
      else{
        this.initNewStockDispatch()
      }
      
    },

    computed: {

      pageType () {
        
        let title = "Add"
        
        if (this.viewMode) {
          title = "View"
        }
        else if(this.$route.params.dispatchId) {
          title = "Edit"
        }

        return title

      },

      hasEnoughStock () {
        
        if (!this.dispatch.items) return false

        let stockLessItems = this.dispatch.items.filter( item => item.quantity > item.stock_quantity )

        return stockLessItems.length > 0 ? false : true

      }

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.dispatchId) {
          this.loadStockDispatch(to.params.dispatchId)
        }
        else{
          this.dispatch = this.initNewStockDispatch()
        }

      },

      itemCodeSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchItemsByCode()
        }
      },

      itemNameSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchItemsByName()
        }
      },

      itemId (val, oldVal) {
        if (val && val !== oldVal) {
          this.upsertItemFromListToDispatch(val)
        }
      },

      'dispatch.factory_id' (val, oldVal) {
        if (val && oldVal && !this.viewMode) {
          this.dispatch.items = []
        }
      }

    },
    
    components: {
      'dispatch-item': StockDispatchItem
    }

  }
</script>
